<template>
    <span v-if="!finding.review.reviewable" class="subtitleGray--text">–</span>
    <BaseTooltip v-else>
        <template v-slot:content>
            <span class="d-inline-flex align-center">
                <v-icon small :color="mark.color" class="mr-1">{{ mark.icon }}</v-icon>
                <span :class="finding.review.decision ? '' : 'subtitleGray--text'">{{ $t(mark.text) }}</span>
                <v-icon v-if="finding.review.customClaimText" x-small class="ml-1" color="standardBrownIcon">edit</v-icon>
            </span>
        </template>
        <template v-slot:text>
            <span v-if="finding.review.reviewedBy">
                {{ $t('lang_PUBLISHING_USAGE_CAPTION_REVIEW_REVIEWED_BY', { name: finding.review.reviewedBy.name, at: finding.review.reviewedAt }) }}
            </span>
            <span v-else>{{ $t(mark.hint) }}</span>
        </template>
    </BaseTooltip>
</template>

<script>
import BaseTooltip from '@/components/_base/BaseTooltip'

/** A finding's review decision; an undecided complaint is still claimed (the export sends it unless rejected). */
export default {
    name: 'DecisionMark',
    components: { BaseTooltip },
    props: {
        finding: { type: Object, required: true }
    },
    computed: {
        mark() {
            const decision = this.finding.review.decision
            if (decision === 'accepted') return { icon: 'check_circle', color: 'buttonNewEntity', text: 'lang_GENERIC_CAPTION_STATUS_ACCEPTED', hint: '' }
            if (decision === 'rejected') return { icon: 'cancel', color: 'error', text: 'lang_GENERIC_CAPTION_STATUS_DECLINED', hint: '' }
            return {
                icon: 'radio_button_unchecked',
                color: 'iconDelete',
                text: 'lang_PUBLISHING_USAGE_CAPTION_DECISION_UNDECIDED',
                hint: this.finding.outcome === 'complaint' ? 'lang_PUBLISHING_USAGE_CAPTION_REVIEW_UNDECIDED_COMPLAINT_HINT' : 'lang_PUBLISHING_USAGE_CAPTION_REVIEW_UNDECIDED_REVIEW_HINT'
            }
        }
    }
}
</script>
